import React, {useEffect, useState} from 'react';

function VaccinationPackage() {
    const [htmlContent, setHtmlContent] = useState('');

    // useEffect(() => {
    //     fetch('/bw_static_html/tiem-chung.html')
    //         .then(res => res.text())
    //         .then(data => setHtmlContent(data));
    // }, []);

    return (
        <iframe
            src="/bw_static_html/tiem-chung.html"
            style={{
                width: '100%',
                height: '100vh',
                border: 'none',
            }}
            title="Landing Page"
        />
    );
}

export default VaccinationPackage;
